<h1 mat-dialog-title class="p-2 text-center">Ajout d'un consommable</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <!-- (selectionChange)="checkLastConsommable()" -->
        @if (TypeOfService === EServiceType.Air) {
        <mat-form-field class="col-12">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Type" [(ngModel)]="Model.Type" required (selectionChange)="checkLastConsommable()">
                @for (o of ConsommableAirList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        @if (TypeOfService === EServiceType.Surface) {
        <mat-form-field class="col-12">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Type" [(ngModel)]="Model.Type" required (selectionChange)="checkLastConsommable()">
                @for (o of ConsommableSurfaceList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
        @if (TypeOfService === EServiceType.Dialyse) {
        <mat-form-field class="col-12">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Type" [(ngModel)]="Model.Type" required (selectionChange)="checkLastConsommable()">
                @for (o of ConsommableDialyseList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Numéro de lot</mat-label>
            <input matInput [(ngModel)]="Model.NumeroLot" placeholder="Numéro de lot">
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Expiration</mat-label>
            <input matInput placeholder="Expiration" [matDatepicker]="picker" [(ngModel)]="Expiration" (click)="picker.open()"
                   (dateChange)="expirationChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <!-- <mat-form-field class="col">
      <input matInput placeholder="Expiration" [ngxTimepicker]="timepicker1" [value]="interventionTimeExpiration" [format]="24" readonly>
      <ngx-material-timepicker #timepicker1 (timeSet)="timeSetExpiration($event)"></ngx-material-timepicker>
    </mat-form-field> -->
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>